
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31","height":"31"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1109 -445)"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","transform":"translate(1111.5 447.5)","fill":"#fff"}}),_c('path',{staticClass:"char",attrs:{"d":"M1124.83 456.739v2.028c0 2.5-1.2 3.855-3.655 3.855h-1.159v5.862h-2.452v-15.6h3.611c2.451-.001 3.655 1.359 3.655 3.855zm-4.814-1.627v5.281h1.159c.779 0 1.2-.356 1.2-1.47v-2.34c0-1.115-.424-1.471-1.2-1.471zM1129.647 459.792h3.432v4.947c0 2.5-1.248 3.923-3.655 3.923s-3.656-1.426-3.656-3.923v-8.112c0-2.5 1.249-3.922 3.656-3.922s3.655 1.426 3.655 3.922v1.515h-2.318v-1.671c0-1.114-.491-1.538-1.27-1.538s-1.271.424-1.271 1.538v8.424c0 1.115.49 1.516 1.271 1.516s1.27-.4 1.27-1.516v-2.874h-1.114z"}}),_c('path',{attrs:{"d":"M1124.5 476a15.5 15.5 0 1115.5-15.5 15.517 15.517 0 01-15.5 15.5zm0-30a14.5 14.5 0 1014.5 14.5 14.517 14.517 0 00-14.5-14.5z","fill":"#fff"}})])])
          )
        }
      }
    